const getQrValue = (name: string, http: boolean = true, utm?: string) => {
  const isDomain = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(name);
  
  const protokol = http ? "https://" : "";
  const _utm = utm ? `?qr=${utm}` : ``;
  return `${protokol}${isDomain ? name : `${process.env.NEXT_PUBLIC_PAGE}/${name}`}${_utm}`;
};
export default getQrValue;
